import React, { useEffect, useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import Toolbar from './__toolbar/advertisingCampaigns__toolbar'
import translate from 'core/translate'
import { routes } from 'features/routes'
import helpers from 'core/helpers'
import { getURLSearchParamsString } from 'features/routes/utils'
import { changeLocation } from 'features/routes'
import { checkAvailableModule } from '../../core/helpers/routes/routes'
import { checkRoutePathName } from 'core/helpers/routes/routes'
import styles from './advertisingCapmaigns'
import { DownloadInfoModal } from '../broadcasts/__downloadInfoModal/broadcasts__downloadInfoModal'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { downloadsActions } from '../../core/services/DownloadService/DownloadService.state'
import { UploadAdvertisements } from './__upload/advertisingCampaigns__upload'
import { advertisingCampaignsActions } from './advertisingCampaigns.state'
import { api } from '../../core/api/ConnectionManager'

const AdvertisingCampaigns = (p_: any) => {
    const [selectedInfo, setSelectedInfo] = useState(null)
    const [selectedItems, setSelectedItems] = useState<any>([])
    const [showDownloadInfo, setShowDownloadInfo] = useState(false)
    const dispatch = useDispatch()
    const downloads: any = useSelector<RootStateOrAny>((state) => state.downloads)
    const advertisingCampaignsState: any = useSelector<RootStateOrAny>((state) => state.advertisingCampaigns)

    const addDelayDownloadTask = (task: { targetId: number; type: string; exportId: string }) => {
        dispatch(downloadsActions.addDelayDownloadTask(task))
    }

    const openImportedAdvertisement = (id: number) => {
        dispatch(downloadsActions.closeModal())
        changeLocation({
            pathname: `/${routes.editAdvertisingAds.path}`,
            search: getURLSearchParamsString({
                advId: id,
            }),
        })
    }

    useEffect(() => {
        const listenersId: string[] = []

        api.addObserver(
            'advertisementCreated',
            (data: any) => {
                if (!advertisingCampaignsState?.waitingImport || !data?.id) return

                dispatch(advertisingCampaignsActions.setWaitingImport(false))
                openImportedAdvertisement(data.id)
            },
            listenersId
        )

        return () => {
            listenersId.forEach((id) => api.removeObserver(id))
        }
    }, [advertisingCampaignsState?.waitingImport])

    return (
        <>
            {showDownloadInfo && (
                <DownloadInfoModal
                    type="advertisement"
                    progressList={downloads.delayDownloadsProgressList}
                    onClose={() => setShowDownloadInfo(false)}
                />
            )}
            {advertisingCampaignsState && advertisingCampaignsState.isOpenAddAdvertisementFile && (
                <UploadAdvertisements />
            )}
            <Content
                className={p_.className}
                title={translate('promotions')}
                frame={p_.frame}
                toolbar={
                    <Toolbar
                        selectedInfo={selectedInfo}
                        selectedItems={selectedItems}
                        onCloseInfo={() => setSelectedInfo(null)}
                        onOpenInfo={() => setShowDownloadInfo(true)}
                        onChange={(selectedItems) => setSelectedItems(selectedItems)}
                        downloads={downloads}
                        addDelayDownloadTask={addDelayDownloadTask}
                    />
                }
                wrapperClassName={styles.aDWrapper}
            >
                <Catalog
                    type={'advertisingCampaigns'}
                    selectedInfo={selectedInfo}
                    onSelectInfo={(selectedInfo: any) => setSelectedInfo(selectedInfo)}
                    onDoubleClickObject={function (advCampaign: any) {
                        if (
                            helpers.isAvailableAction(advCampaign, {
                                key: 'advertisingCampaign',
                                action: 'update',
                            })
                        ) {
                            changeLocation({
                                pathname: checkRoutePathName('/advertisingAds')
                                    ? `/${routes.editAdvertisingAds.path}`
                                    : `/${routes.editAdvertisingCampaign.path}`,
                                search: getURLSearchParamsString({
                                    advId: advCampaign.id,
                                }),
                            })
                        }
                    }}
                    selectedItems={selectedItems}
                    onSelect={(selectedItems: any) => setSelectedItems(selectedItems)}
                    fixedHeader={true}
                />
            </Content>
        </>
    )
}

const exportAdvertisingCampaigns = checkAvailableModule('advertisingCampaigns') ? AdvertisingCampaigns : null

export default exportAdvertisingCampaigns
